<!--
 * @Author: 赵健
 * @Date: 2021-01-19 09:50:32
 * @LastEditTime: 2021-02-01 15:43:23
 * @LastEditors: 赵健
 * @Description: 新增/编辑权益
 * @FilePath: \Develop1.0.0\src\views\merchantCenter\equityManage\add.vue
-->
<template>
  <div v-loading="loading">
    <um-bread-crumb />
    <el-form
      ref="form"
      :model="form"
      label-width="120px"
    >
      <el-card shadow="never">
        <div
          slot="header"
          class="card-header"
        >
          <span>基础信息</span>
        </div>
        <el-form-item
          ref="classId"
          label="所属板块/分类:"
          prop="classId"
          :rules="[
            {required: true, message: '必填项不能为空', trigger: 'blur' },
          ]"
        >
          <el-select-tree
            v-model="form.classId"
            :is-leaf="true"
            placeholder="请选择所属板块/分类"
            style="width: 100%;"
            :options="classifyListData"
            :default-props="defaultProps"
          />
        </el-form-item>

        <el-form-item
          ref="equityName"
          label="权益名称:"
          prop="equityName"
          :rules="[
            {max:30,min:1, message: '长度在1到30个字符', trigger: 'change' },
            {required: true, message: '必填项不能为空', trigger: 'blur' },
          ]"
        >
          <el-input
            v-model="form.equityName"
            style="width:100%"
            placeholder="请输入权益名称"
          />
        </el-form-item>

        <el-form-item
          ref="equityDescription"
          label="权益描述:"
          prop="equityDescription"
          :rules="[
            {max:200,min:1, message: '长度在1到200个字符', trigger: 'change' },
          ]"
        >
          <el-input
            v-model="form.equityDescription"
            type="textarea"
            style="width:100%"
            placeholder="请输入权益描述"
          />
        </el-form-item>
        <el-form-item
          ref="equityDesignNoList"
          label="权益封面图:"
          prop="equityDesignNoList"
        >

          <um-upload-img
            v-model="form.equityDesignNoList"
            style="width: 100%;"
            :limit="5"
            :is-cropper="true"
            :simple="true"
            :cropper-options="{
              aspectRatio: 14 / 9
            }"
            placeholder="建议尺寸14:9"
          />
        </el-form-item>

        <!-- <el-form-item label="商家:">
          <el-input
            v-model="form.merchantName"
            style="width:100%"
            :disabled="true"
          />
        </el-form-item> -->

        <el-form-item
          ref="equityValue"
          label="价值:"
          prop="equityValue"
        >
          <el-input-number
            v-model="form.equityValue"
            style="width:500px"
            controls-position="right"
            :precision="2"
            :min="0"
            :max="999999999"
          />
          <span style="margin-left:10px;">元</span>
        </el-form-item>

        <el-form-item
          ref="equityNeedAppointment"
          label="是否需要预约:"
          prop="equityNeedAppointment"
        >
          <el-radio-group v-model="form.equityNeedAppointment">
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          ref="equitySumNumber"
          label="权益总数量:"
          prop="equitySumNumber"
        >
          <el-input-number
            v-model="form.equitySumNumber"
            style="width:500px"
            controls-position="right"
            :min="1"
            :max="999999999"
            :precision="0"
          />
        </el-form-item>

        <el-form-item label="权益时限:">
          <el-date-picker
            v-model="day"
            type="daterange"
            style="width:500px"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>

        <el-form-item label="权益使用时间段:">
          <el-time-picker
            v-model="time"
            is-range
            arrow-control
            style="width:500px"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
          />
        </el-form-item>

        <el-form-item label="详细说明:">
          <tinymce
            v-model="form.remark"
            :url="form.equityRemark"
            :height="300"
          />
        </el-form-item>

      </el-card>

      <el-card
        v-if="type==1"
        shadow="never"
      >
        <div
          slot="header"
          class="card-header"
        >
          <span>关联会员</span>
        </div>
        <el-form-item
          ref="equitySumNumber"
          label="享受会员:"
          prop="equitySumNumber"
        >
          <el-checkbox-group v-model="selectMember">
            <el-checkbox
              v-for="(item,index) in memberData"
              :key="index"
              :label="item"
            >{{ item.memLevelName }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div
          v-for="(item,index) in selectMember"
          :key="index"
          class="member-box"
        >
          <div>{{ item.memLevelName }}</div>
          <div class="margin-t-10">
            <span>权益类型：</span>
            <el-radio-group v-model="item.equityType">
              <el-radio :label="0">会员专享</el-radio>
              <el-radio :label="1">积分兑换</el-radio>
            </el-radio-group>
            <el-input-number
              v-model="item.consumptionPoints"
              style="width:150px;margin-left:10px;"
              controls-position="right"
              :min="1"
              :max="999999999"
              placeholder="请输入所需积分"
            />
          </div>
          <div class="margin-t-10">
            <span>折扣力度：</span>
            <el-radio-group v-model="item.discount">
              <el-radio :label="0">免费享受</el-radio>
              <el-radio :label="1">享受折扣</el-radio>
            </el-radio-group>
            <el-input-number
              v-model="item.discountValue"
              :precision="2"
              style="width:150px;margin-left:10px;"
              controls-position="right"
              :min="0"
              :max="10"
              placeholder="请输入折扣"
            />
            <span style="margin-left:10px;">折</span>
          </div>
          <div class="margin-t-10">
            <span>使用限制：</span>
            <el-radio-group v-model="item.whetherToLimit">
              <el-radio :label="0">不限次数</el-radio>
              <el-radio :label="1">限制次数</el-radio>
            </el-radio-group>
            <el-input-number
              v-model="item.frequency"
              style="width:150px;margin-left:10px;"
              controls-position="right"
              :min="1"
              :max="999999999"
              placeholder="请输入次数"
            />
            <span style="margin-left:10px;">次/</span>
            <el-select
              v-model="item.timesUnit"
              style="width: 100px;margin-left:10px;"
              placeholder="请选择时间单位"
            >
              <el-option
                v-for="(value,key) in timeUnit"
                :key="key"
                :label="value"
                :value="key"
              />
            </el-select>
          </div>

        </div>
      </el-card>
      <el-button
        type="primary"
        style="display:block;margin:20px auto;"
        @click="saveForm"
      >保 存</el-button>
    </el-form>
  </div>
</template>
<script>
import { deepClone } from "@/utils";
import {
  merchantMemberAddEqConfig,
  merchantEquityDetail,
  merchantModuleParamList,
  merchantEquityAdd,
  merchantEquityEdit
} from "@/api/merchantCenter";
import Tinymce from "@/components/Tinymce";
import moment from "moment";
export default {
  name: "MerchantEquityManageAdd",
  components: {
    Tinymce
  },
  data() {
    return {
      type: 1, // 1新增2修改
      equityId: null,
      loading: false,
      form: {
        classId: null,
        equityName: "",
        equityDescription: "",
        equityDesignNoList: [],
        equityValue: 0,
        equityNeedAppointment: 1,
        equitySumNumber: null,
        equityRemark: "",
        remark: ""
      },
      classifyListData: [],
      memberData: [],
      timeUnit: {
        0: "日",
        1: "月",
        2: "年"
      },
      defaultProps: {
        value: "classId", // 唯一标识
        label: "categoryName", // 标签显示
        children: "classList" // 子级
      },
      day: [],
      time: [new Date(), new Date()],
      selectMember: []
    };
  },
  created() {
    this.type = this.$route.query.type;
    this.equityId = this.$route.query.equityId;
    if (this.type == 1) {
      // 新增
      this.getMerchantMemberAddEqConfig();
    } else if (this.type == 2 && this.equityId) {
      // 修改
      this.getInfo();
    } else {
      return this.$router.go(-1);
    }
    this.getMerchantModuleParamList();
  },
  methods: {
    // 板块 分类下拉树
    async getMerchantModuleParamList() {
      try {
        this.loading = true;
        const res = await merchantModuleParamList();
        this.classifyListData = res.data.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    // 获取所有会员等级信息
    async getMerchantMemberAddEqConfig() {
      try {
        this.loading = true;
        const res = await merchantMemberAddEqConfig();
        res.data.forEach(i => {
          i.equityType = 0; // 权益类型   0/会员   1/积分
          i.consumptionPoints = 1; // 积分数
          i.discount = 0; // 是否折扣  0 免费  1 折扣
          i.discountValue = 10; // 折扣数
          i.whetherToLimit = 0; // 是否存在次数限制   1 是  0 否
          i.frequency = 1; // 次数
          i.timesUnit = "0"; // 时间单位 天0月1年2
        });
        this.memberData = res.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    // 编辑回显
    async getInfo() {
      try {
        this.loading = true;
        const res = await merchantEquityDetail({ equityId: this.equityId });
        this.form = deepClone(res.data.equityManagementRecordVo);
        this.form.equityDesignNoList =
          res.data.equityManagementRecordVo.equityDesignNoList || [];
        this.day = [
          res.data.equityManagementRecordVo.equityEffectiveStartTime,
          res.data.equityManagementRecordVo.equityEffectiveEndTime
        ];

        const a = res.data.equityManagementRecordVo.equityUseStartTime
          ? res.data.equityManagementRecordVo.equityUseStartTime.split(":")
          : null;
        const b = res.data.equityManagementRecordVo.equityUseStartTime
          ? res.data.equityManagementRecordVo.equityUseEndTime.split(":")
          : null;
        this.time = [
          a ? new Date(2020, 1, 1, a[0], a[1], a[2]) : null,
          b ? new Date(2020, 1, 1, b[0], b[1], b[2]) : null
        ];
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    saveForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.loading = true;
            if (this.type == 1) {
              const obj = {
                classId: this.form.classId,
                equityName: this.form.equityName,
                equityDescription: this.form.equityDescription,
                equityDesignNoList: this.form.equityDesignNoList,
                equityValue: this.form.equityValue,
                equitySumNumber: this.form.equitySumNumber,
                equityNeedAppointment: this.form.equityNeedAppointment,
                equityRemark: this.form.remark,
                equityEffectiveStartTime: this.day[0]
                  ? moment(this.day[0]).format("YYYY-MM-DD")
                  : null,
                equityEffectiveEndTime: this.day[1]
                  ? moment(this.day[1]).format("YYYY-MM-DD")
                  : null,
                equityUseStartTime: this.time[1]
                  ? moment(this.time[0]).format("HH:mm:ss")
                  : null,
                equityUseEndTime: this.time[1]
                  ? moment(this.time[1]).format("HH:mm:ss")
                  : null,
                equityMemberLevelConfigurationList: this.selectMember.map(
                  i => ({
                    memberLevelId: i.memberLevelId,
                    equityType: i.equityType,
                    consumptionPoints:
                      i.equityType == 1 ? i.consumptionPoints : undefined,
                    discount: i.discount,
                    discountValue:
                      i.discount == 1 ? i.discountValue : undefined,
                    whetherToLimit: i.whetherToLimit,
                    frequency: i.whetherToLimit == 1 ? i.frequency : undefined,
                    timesUnit: i.whetherToLimit == 1 ? i.timesUnit : undefined
                  })
                )
              };
              await merchantEquityAdd(obj);
            } else {
              const obj = {
                equityId: this.equityId,
                classId: this.form.classId,
                equityName: this.form.equityName,
                equityDescription: this.form.equityDescription,
                equityDesignNoList: this.form.equityDesignNoList,
                equityValue: this.form.equityValue,
                equitySumNumber: this.form.equitySumNumber,
                equityNeedAppointment: this.form.equityNeedAppointment,
                equityRemark: this.form.remark,
                equityEffectiveStartTime:
                  this.day && this.day[0]
                    ? moment(this.day[0]).format("YYYY-MM-DD")
                    : null,
                equityEffectiveEndTime:
                  this.day && this.day[1]
                    ? moment(this.day[1]).format("YYYY-MM-DD")
                    : null,
                equityUseStartTime:
                  this.time && this.time[1]
                    ? moment(this.time[0]).format("HH:mm:ss")
                    : null,
                equityUseEndTime:
                  this.time && this.time[1]
                    ? moment(this.time[1]).format("HH:mm:ss")
                    : null
              };
              await merchantEquityEdit(obj);
            }
            this.loading = false;
            this.$message.success("操作成功！");
            this.$router.go(-1);
          } catch (e) {
            console.log(e);
            this.loading = false;
          }
        } else {
          this.$message.warning("请输入正确的表单！");
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.member-box {
  border-radius: 5px;
  padding: 20px;
  border: 1px solid #918b8b;
  margin-bottom: 20px;
}
</style>


